import React from "react";
import {
  Grid,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { PhotoUploaderStyles } from "./PhotoUploaderStyles";
import PhotosUploadUtil, { truncateFileName } from "./PhotosUploadUtil";
import CloseIcon from "@material-ui/icons/Close";
import VINLOC from "../assets/images/vin-locations.png";
import "./photosstyle.css";
import {
  FILE_SIZE_ERROR,
  FILE_TYPE_ERROR,
  MAX_ALLOWED_PHOTO_SIZE_IN_MB,
} from "../constants/GlobalConstants";

export const VehicleInfo = (props: any) => {
  const classes = PhotoUploaderStyles();
  const [showModal, setShowModal] = React.useState(false);
  const [vinError, setVinError] = React.useState(undefined);
  const [vinErrorMessage, setVinErrorMessage] = React.useState(FILE_SIZE_ERROR);
  const [imgPreview, setImgPreview] = React.useState(undefined);
  const [imgPreviewName, setImgPreviewName] = React.useState(undefined);
  const [imgOdoPreviewName, setImgOdoPreviewName] = React.useState(undefined);
  const [imgOdoPreview, setImgOdoPreview] = React.useState(undefined);
  const [odoError, setOdoError] = React.useState(undefined);
  const [odoErrorMessage, setOdoErrorMessage] = React.useState(FILE_SIZE_ERROR);
  const handleOpenVINModal = () => {
    console.log("Show VIN Screen");
    setShowModal(true);
  };
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));

  const handleCloseModal = () => {
    console.log("Close VIN Screen");
    setShowModal(false);
  };

  function vinDropHandler(ev) {
    ev.preventDefault();
    if (ev.dataTransfer.items[0].kind === "file") {
      setVinError(false);
      let image = new Image();
      let fileInfoArr = [];
      const selected = ev.dataTransfer.items[0].getAsFile();
      let selectedFile = ev.dataTransfer.items[0].getAsFile();
      console.log(selected.size);
      let selectedFileSize = selected.size / 1024 / 1024; // in MB
      const ALLOWED_TYPES = ["image/jpeg", "image/jpg"];
      if (selected && ALLOWED_TYPES.includes(selected.type)) {
        console.log("Selected");
        let reader = new FileReader();
        console.log(selected.ALLOWED_TYPES);
        if (selectedFileSize > MAX_ALLOWED_PHOTO_SIZE_IN_MB) {
          console.log("file size error");
          setVinErrorMessage(FILE_SIZE_ERROR);
          setVinError(true);
          return;
        }

        reader.onloadend = () => {
          if (reader !== null && typeof reader.result == "string") {
            image.src = reader.result;
          }
          image.onload = () => {
            const width = image.width;
            const height = image.height;
            console.log("image Width" + width + "X" + height);
            if (width < 800 || height < 600) {
              selectedFile = PhotosUploadUtil(height, width, image, selected);
            } else {
              selectedFile = selected;
            }
            setImgPreview(reader.result);
            selectedFile.imageLabel = "VIN";
            selectedFile.additionalDescription = "VIN";
            selectedFile.imageDisplayFileName = selected.name;
            setImgPreviewName(selected.name);
            fileInfoArr.push(selectedFile);
            props.updatePhotoFile(selectedFile);
            console.log(fileInfoArr.length);
          };
        };
        reader.readAsDataURL(selected);
      } else {
        console.log("file type error");
        setVinErrorMessage(FILE_TYPE_ERROR);
        setVinError(true);
      }
    }
  }

  const handleEvent = (e) => {
    console.log(e.target.id);

    if (e.target.files.length > 1) {
    } else {
      let fileInfoArr = [];
      const selected = e.target.files[0];
      let selectedFile = e.target.files[0];
      const selectID = e.target.id;
      console.log(selected.name);
      let selectedFileSize = selected.size / 1024 / 1024; // in MB
      if (selectID === "drop_vin_bt") {
        setVinError(false);
        console.log(vinError);
      } else if (selectID === "drop_odo_bt") {
        setOdoError(false);
      }
      const ALLOWED_TYPES = ["image/jpeg", "image/jpg"];
      let image = new Image();
      if (
        selected &&
        ALLOWED_TYPES.includes(selected.type) &&
        selectedFileSize <= MAX_ALLOWED_PHOTO_SIZE_IN_MB
      ) {
        console.log("Selected");
        let reader = new FileReader();
        console.log(selected.ALLOWED_TYPES);
        reader.onloadend = () => {
          if (reader !== null && typeof reader.result == "string") {
            image.src = reader.result;
          }
          image.onload = () => {
            const width = image.width;
            const height = image.height;
            console.log("image Width" + width + "X" + height);
            if (width < 800 || height < 600) {
              selectedFile = PhotosUploadUtil(height, width, image, selected);
            } else {
              selectedFile = selected;
            }

            if (selectID === "drop_vin_bt") {
              setImgPreview(reader.result);
              selectedFile.imageLabel = "VIN";
              selectedFile.additionalDescription = "VIN";
              selectedFile.imageDisplayFileName = selected.name;
              console.log(
                "File Name " + selected.name + "   " + selectedFile.imageLabel
              );
              setImgPreviewName(selected.name);
            } else if (selectID === "drop_odo_bt") {
              setImgOdoPreview(reader.result);
              selectedFile.imageLabel = "Odometer";
              selectedFile.additionalDescription = "Odometer";
              selectedFile.imageDisplayFileName = selected.name;
              setImgOdoPreviewName(selected.name);
            }
            fileInfoArr.push(selectedFile);
            props.updatePhotoFile(selectedFile);
            console.log(fileInfoArr.length);
          };
        };
        reader.readAsDataURL(selected);
      } else if (selectedFileSize > MAX_ALLOWED_PHOTO_SIZE_IN_MB) {
        console.log("Error: File size is more than 10 MB");
        if (selectID === "drop_vin_bt") {
          setVinErrorMessage(FILE_SIZE_ERROR);
          setVinError(true);
          console.log(vinError);
        } else if (selectID === "drop_odo_bt") {
          setOdoError(true);
          setOdoErrorMessage(FILE_SIZE_ERROR);
        }
      } else {
        console.log("Error: File not supported");
        if (selectID === "drop_vin_bt") {
          setVinErrorMessage(FILE_TYPE_ERROR);
          setVinError(true);
          console.log(vinError);
        } else if (selectID === "drop_odo_bt") {
          setOdoError(true);
          setOdoErrorMessage(FILE_TYPE_ERROR);
        }
      }
    }
  };

  function dragOverHandler(ev) {
    console.log("File(s) in drop zone");
    ev.preventDefault();
  }

  // odometer setting for drag
  function odoDropHandler(ev) {
    console.log(ev.dataTransfer.items);
    setOdoError(false);
    ev.preventDefault();

    if (ev.dataTransfer.items[0].kind === "file") {
      let image = new Image();
      const selected = ev.dataTransfer.items[0].getAsFile();
      let selectedFile = ev.dataTransfer.items[0].getAsFile();
      let selectedFileSize = selected.size / 1024 / 1024; // in MB
      const ALLOWED_TYPES = ["image/jpeg", "image/jpg"];
      if (selected && ALLOWED_TYPES.includes(selected.type)) {
        console.log("Selected");
        let reader = new FileReader();
        console.log(selectedFileSize);
        if (selectedFileSize > MAX_ALLOWED_PHOTO_SIZE_IN_MB) {
          console.log("invalid size");
          setOdoError(true);
          setOdoErrorMessage(FILE_SIZE_ERROR);
          return;
        }

        reader.onloadend = () => {
          console.log("onlaoded");
          if (reader !== null && typeof reader.result == "string") {
            console.log("setting image src");
            image.src = reader.result;
          }

          image.onload = () => {
            const width = image.width;
            const height = image.height;
            console.log("image Width" + width + "X" + height);
            if (width < 800 || height < 600) {
              selectedFile = PhotosUploadUtil(height, width, image, selected);
            } else {
              selectedFile = selected;
            }
            setImgOdoPreview(reader.result);
            selectedFile.imageLabel = "Odometer";
            selectedFile.additionalDescription = "Odometer";
            selectedFile.imageDisplayFileName = selected.name;
            setImgOdoPreviewName(selected.name);
            props.updatePhotoFile(selectedFile);
          };
        };
        console.log("readasdataurl");
        console.log(selected);
        reader.readAsDataURL(selected);
      } else {
        setOdoError(true);
        setOdoErrorMessage(FILE_TYPE_ERROR);
      }
    }
  }

  function VinInfoDetails() {
    return (
      <Dialog
        open={showModal}
        onClose={handleCloseModal}
        disableEscapeKeyDown
        fullWidth={true}
        maxWidth={"sm"}
        data-testid={"vin_modal"}
        classes={{
          scrollPaper: classes.scrollPaper,
        }}
      >
        <DialogTitle>
          Where do I find my vehicle identification number (VIN)?
        </DialogTitle>
        <DialogContent>
          <p className="logoImage" style={{ padding: "10px" }}>
            <img src={VINLOC} alt="VINLOC" width="95%" height="60%" />
          </p>
          <br />
          <Typography className={classes.vinDesc}>
            You may be able to find your VIN on the driver side door jamb, the
            interior of the driver side of your dashboard, between your front
            carb and your windshield washing unit, and under your hood on the
            front of your engine.{" "}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            data-testid={"vin_modal_close"}
            onClick={handleCloseModal}
            className={classes.cBtnColor}
            color="primary"
            variant="text"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
  function deleteVinFile() {
    setImgPreview(null);
    props.deleteVinFile();
  }
  function deleteOdoFile() {
    setImgOdoPreview(null);
    props.deleteOdoFile();
  }

  function deleteVinErrorFile() {
    setVinError(false);
  }
  function deleteOdoErrorFile() {
    setOdoError(false);
  }

  function onOdoFileSelectClick() {
    try {
      let elm = document.getElementById("drop_odo_bt");
      elm.click();
    } catch {}
  }

  function onVinFileSelectClick() {
    try {
      let elm = document.getElementById("drop_vin_bt");
      elm.click();
    } catch {}
  }

  return (
    <div>
      <Grid container spacing={2}>
        <Grid item xs={12} className={classes.vehicleInfo}>
          <Typography className={classes.vehicleInfo}>
            Vehicle Information
          </Typography>
        </Grid>
        <Grid item xs={12} md={6} container className={classes.vehInfoDetails}>
          <Typography className={classes.vehInfoDetails}>
            Vehicle Identification Number (VIN)
          </Typography>
          <Grid item xs={12}>
            <Typography
              data-testid={"launch_modal"}
              className={classes.vehicleInfoLoc}
              onClick={handleOpenVINModal}
            >
              Where do I find this?
            </Typography>
          </Grid>

          <Grid
            xs={12}
            item
            className={classes.dropZone}
            id="drop_zone"
            onDrop={vinDropHandler}
            onDragOver={dragOverHandler}
            onClick={onVinFileSelectClick}
            data-testid={"drop_zone_vin"}
          >
            {!vinError ? (
              !imgPreview ? (
                <Grid className={classes.container}>
                  <Grid container alignItems="center">
                    <Grid item xs={3} sm={12}>
                      <input
                        type="file"
                        id="drop_vin_bt"
                        className={classes.input}
                        accept=".jpeg,.jpg"
                        onChange={handleEvent}
                        data-testid="drop_vin_bt"
                      />

                      <span className={`${classes.icon} icon-vin`}></span>
                    </Grid>
                    <Grid item xs={9} sm={12}>
                      <label className={classes.regularText}>
                        Drag & drop a file here or click to select a file
                      </label>
                    </Grid>
                  </Grid>
                </Grid>
              ) : (
                <Grid style={{ textAlign: "center" }}>
                  <Grid container>
                    <Grid item xs={2} md={5}>
                      <img
                        id="clickImg2"
                        src={imgPreview}
                        className={
                          isMobile
                            ? classes.imagePreviewMobile
                            : classes.imagePreview
                        }
                        alt=""
                      />
                    </Grid>
                    <Grid item xs={8} md={5} className={classes.imagePrevName}>
                      <Typography className={classes.imageName}>
                        {truncateFileName(imgPreviewName)}
                      </Typography>
                    </Grid>
                    <Grid
                      container
                      xs={2}
                      style={{ alignContent: "center" }}
                      item
                    >
                      <Button
                        color="default"
                        startIcon={<CloseIcon />}
                        onClick={() => deleteVinFile()}
                        className={classes.rightButton}
                        data-testid={"delete_vin"}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              )
            ) : (
              <Grid
                style={{
                  textAlign: "center",
                  paddingRight: "30px",
                  paddingLeft: "30px",
                }}
              >
                <Grid container>
                  <Grid container item xs={11} style={{ padding: "1rem" }}>
                    <Grid
                      item
                      xs={10}
                      md={6}
                      style={{ alignContent: "center" }}
                    >
                      <span
                        className="icon-no-image"
                        style={{
                          fontSize: "45px",
                          color: "#8A0200",
                        }}
                      ></span>
                    </Grid>
                    <Grid item xs={10} md={6}>
                      <label className={classes.errorText}>
                        {vinErrorMessage}
                        <br />
                        <br /> Please select another photo.
                      </label>
                    </Grid>
                  </Grid>

                  <Grid container item alignContent="center" xs={1}>
                    <Button
                      color="default"
                      startIcon={<CloseIcon />}
                      onClick={() => deleteVinErrorFile()}
                      className={classes.rightButton}
                      data-testid={"delete_vin_error"}
                    />
                  </Grid>
                </Grid>
              </Grid>
            )}
          </Grid>
        </Grid>

        <Grid container item xs={12} md={6} className={classes.vehInfoDetails}>
          <Typography className={classes.vehInfoDetails}>
            Vehicle’s Mileage (Odometer)
          </Typography>

          <Grid
            item
            xs={12}
            className={classes.dropZone}
            id="drop_zone"
            onDrop={odoDropHandler}
            onDragOver={dragOverHandler}
            onClick={onOdoFileSelectClick}
            data-testid={"drop_zone_odo"}
          >
            {!odoError ? (
              !imgOdoPreview ? (
                <Grid className={classes.container}>
                  <Grid container alignItems="center">
                    <Grid item xs={3} sm={12}>
                      <input
                        type="file"
                        id="drop_odo_bt"
                        data-testid={"drop_zone_bt"}
                        className="fileUpload"
                        style={{ display: "none" }}
                        accept=".jpeg,.jpg"
                        onChange={handleEvent}
                      />

                      <span className={classes.icon + " icon-odometer"}></span>
                    </Grid>
                    <Grid item xs={9} sm={12}>
                      <label className={classes.regularText}>
                        {"Drag & drop a file here or click to select a file"}
                      </label>
                    </Grid>
                  </Grid>
                </Grid>
              ) : (
                <>
                  <Grid container>
                    <Grid container justify="flex-end">
                      <Grid item xs={2} md={5}>
                        <img
                          id="clickImg2"
                          src={imgOdoPreview}
                          className={
                            isMobile
                              ? classes.imagePreviewMobile
                              : classes.imagePreview
                          }
                          alt=""
                        />
                      </Grid>
                      <Grid
                        item
                        xs={8}
                        md={5}
                        className={classes.imagePrevName}
                      >
                        <Typography className={classes.imageName}>
                          {truncateFileName(imgOdoPreviewName)}
                        </Typography>
                      </Grid>
                      <Grid item xs={2} style={{ alignContent: "center" }}>
                        <Button
                          color="default"
                          data-testid={"delete_odo"}
                          startIcon={<CloseIcon />}
                          onClick={() => deleteOdoFile()}
                          className={classes.rightButton}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </>
              )
            ) : (
              <Grid
                style={{
                  textAlign: "center",
                  paddingRight: "30px",
                  paddingLeft: "30px",
                }}
              >
                <Grid container>
                  <Grid container item xs={11} style={{ padding: "1rem" }}>
                    <Grid
                      item
                      xs={10}
                      md={6}
                      style={{ alignContent: "center" }}
                    >
                      <span
                        className="icon-no-image"
                        style={{
                          fontSize: "45px",
                          color: "#8A0200",
                        }}
                      ></span>
                    </Grid>
                    <Grid item xs={10} md={6}>
                      <label className={classes.errorText}>
                        {odoErrorMessage}
                        <br />
                        <br /> Please select another photo.
                      </label>
                    </Grid>
                  </Grid>

                  <Grid container item alignContent="center" xs={1}>
                    <Button
                      color="default"
                      startIcon={<CloseIcon />}
                      onClick={() => deleteOdoErrorFile()}
                      className={classes.rightButton}
                      data-testid={"delete_odo_error"}
                    />
                  </Grid>
                </Grid>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
      <div>{showModal ? <VinInfoDetails /> : null}</div>
    </div>
  );
};
export default VehicleInfo;
